import { useEffect, useMemo } from "react";
import { useRouteLoaderData, useSearchParams } from "react-router-dom";
import { BaseCustomSelector } from "components/base-custom-selector";
import { useLandlordSettingsProvider } from "contexts/landlord-settings-provider";
import type { LandlordSettingsLoaderData } from "types/landlord-settings-loader-data";

export function OwnershipSelector() {
  const { ownershipId: selectedOwnershipId, setOwnershipId } =
    useLandlordSettingsProvider();
  const [, setSearchParams] = useSearchParams();
  const data = useRouteLoaderData(
    "landlord-root",
  ) as LandlordSettingsLoaderData;
  const ownerships = useMemo(() => data?.ownerships.data ?? [], [data]);

  useEffect(() => {
    if (ownerships.length === 0) return;

    const exists = ownerships.find((o) => o.id === selectedOwnershipId);

    if (!selectedOwnershipId || !exists) {
      setOwnershipId(ownerships[0].id);
    }
  }, [ownerships, selectedOwnershipId, setOwnershipId]);

  const optionGroups = [
    {
      label: { id: "ownerships", value: "Ownerships" },
      options: ownerships.map((o) => ({
        label: o.display_name,
        value: o.id,
      })),
    },
  ];

  return (
    <BaseCustomSelector
      selectedValue={selectedOwnershipId}
      optionGroups={optionGroups}
      handleOnChange={(value) => {
        setOwnershipId(value);

        // Every landlord filter in the URL belongs to one ownership, so none of it survives the switch.
        // it should clear all the filters
        setSearchParams(new URLSearchParams(), { replace: true });
      }}
      title={"Ownerships"}
    />
  );
}
